import {
    apiRequest,
    perjalananDinasListIzin
} from "../../../../../../services/adapters/kepegawaian/perjalananDinasService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", perjalananDinasListIzin, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

}

export default DataTableRepository